import { useMemo } from 'react';
import { validateIsVisibleComponent } from '../utils/date-time.es.js';

const useTimeVisibility = (items, isEditingMode = false) => {
  const displayItems = useMemo(() => {
    return items == null ? void 0 : items.filter((item) => {
      return !isEditingMode ? validateIsVisibleComponent((item == null ? void 0 : item.timeVisibility) || {}) : true;
    });
  }, [isEditingMode, items]);
  return {
    displayItems
  };
};

export { useTimeVisibility };
